const config = require('./config.yaml');
const text = require('./text.yaml')[templateVars.lang];

var $accordion = $('.accordion:not(.accordion--no-hash)'),
	hashStack = [];

if (config.showArticleCloseBtnCondition == 'always') {
	$('.accordion__article').append(`<div class="article-close"></div>`);
}

global.updateAccordionsSelectors = function () {
	$accordion = $('.accordion');
};

global.checkAccordionsHash = function () {
	checkHash({scroll: true});
};

$(window).on('pageUpdate', global.updateAccordionsSelectors);

global.getAccordionHash = function () {
	const data = {};
	data.hash = window.location.hash.split('!');
	data.href = data.hash[0];
	data.ePath = data.hash[1];
	data.name = data.href.substr(1);
	data.type = undefined;

	if ($accordion.find(`.accordion__button[href="${data.href}"]`).length) {
		data.type = 'accordion';
	}

	return data;
};

function checkHash(options) {
	var data = global.getAccordionHash();

	openParents(data);

	if (data.type === 'accordion') {
		openAccordion(data, options.scroll);
	}
}

function openParents(data) {
	const $parents = $(`[href="${data.href}"]`).parents('.accordion__section');
	$parents.each(function (index) {
		var $this = $(this);
		if ($this.hasClass('accordion__section')) {
			var name = $this.find('.accordion__button').attr('href');
			openAccordion({href: name});
		}
	});
}

function openAccordion(data, scroll) {
	var $thisSection = $accordion.find(`[href="${data.href}"]`).closest('.accordion__section');

	if (!$accordion.find(`[href="${data.href}"]`).hasClass('is-expand')) {
		$(window).trigger('onAccordeonOpenStart', [$thisSection]);
		$thisSection
			.children('.accordion__header')
			.children('.accordion__button')
			.addClass('is-expand');
		$thisSection
			.children('.accordion__article')
			.addClass('is-expand')
			.velocity('slideDown', {
				complete: function () {
					$(window).trigger('onAccordeonOpenEnd', [$thisSection]);
				}
			});

		if (!config.closeInsideAccordionsOnClose) {
			$thisSection
				.find('.accordion__button.is-expand')
				.each(function (i, element) {
					var currentHref = $(element).attr('href');

					if (hashStack.indexOf(currentHref)) {
						hashStack.push(currentHref);
					}
				});
		} else {
			hashStack.push(data.href);
		}

		if (config.accordionIsSingle) {
			const $sectionForClose = $thisSection
				.siblings('.accordion__section')
				.find('.accordion__button.is-expand');

			closeAccordion($sectionForClose);
		}
	}

	if (config.showArticleCloseBtnCondition == 'longerThanWindow') {
		const currentSectionHeight = $thisSection.children('.accordion__header').height() + $thisSection.children('.accordion__article').innerHeight();

		if (currentSectionHeight > $(window).height() && !$thisSection.find('.article-close').length) {
			$thisSection.find('.accordion__article').append('<div class="article-close"></div>');
		}
	}

	if (scroll) {
		setTimeout(function () {
			scrollToElement(data.href);
		}, 0);
	}
}

function closeAccordion($element) {
	var $enclosedAccordion = $element.closest('.accordion__section');

	$enclosedAccordion.find('.accordion__button').each(function (i, element) {
		var elemIndex = hashStack.indexOf($(element).attr('href'));
		if (elemIndex > -1) {
			hashStack.splice(elemIndex, 1);
		}
	});

	var hash = hashStack[hashStack.length - 1];

	window.location.hash = hash || '!';

	if (config.scrollOnClose) {
		scrollToElement($element.attr('href'));
	}

	slideUpAddClasses($enclosedAccordion);
}

function slideUpAddClasses(elem) {
	if (config.closeInsideAccordionsOnClose) {
		elem
			.find('.accordion__button')
			.removeClass('is-expand');
		elem
			.find('.accordion__article')
			.removeClass('is-expand')
			.velocity('slideUp');
	} else {
		elem
			.children('.accordion__header')
			.children('.accordion__button')
			.removeClass('is-expand');
		elem
			.children('.accordion__article')
			.removeClass('is-expand')
			.velocity('slideUp');
	}
}

function closeAccordionEvent(event) {
	event.preventDefault();
	closeAccordion($(this));
}

function scrollToElement(href) {
	var topPos = $(`[href="${href}"]`).offset().top;
	$('html')
		.velocity('scroll', {
			offset: topPos + 'px',
			duration: 400,
			mobileHA: false
		});
}

checkHash({scroll: true});

$(window).on('hashchange', checkHash);

$(document).on('click', '.accordion:not(.accordion--no-hash) .accordion__button.is-expand', closeAccordionEvent);
$(document).on('click', '.accordion:not(.accordion--no-hash) .article-close', function () {
	var $element = $(this).closest('.accordion__section').find('.accordion__button.is-expand');

	closeAccordion($element);
});

if (config.scrollOnOpen) {
	$(document).on('click', '.accordion:not(.accordion--no-hash) .accordion__button', function () {
		scrollToElement($(this).attr('href'));
	});
}

$('.control-item--expand').on('click', function () {
	$(this).closest('.accordion:not(.accordion--no-hash)').find('.accordion__button').each(function (i, elem) {
		var $this = $(elem);
		var currentHref = $this.attr('href');

		if (hashStack.indexOf(currentHref) === -1) {
			var data = {href: currentHref};

			openAccordion(data);
		}
	});

	window.location.hash = hashStack[hashStack.length - 1] || '!';
});

$('.control-item--collapse').on('click', function () {
	$(this).closest('.accordion:not(.accordion--no-hash)').find('.accordion__button').each(function (i, elem) {
		var currentHref = $(elem).attr('href');
		var indexOfElem = hashStack.indexOf(currentHref);
		var currentSection = $(elem).closest('.accordion__section');

		if (indexOfElem > -1) {
			slideUpAddClasses(currentSection);
			hashStack.splice(hashStack.indexOf($(elem).attr('href')), 1);
		}
	});

	window.location.hash = hashStack[hashStack.length - 1] || '!';
});

if ($('.accordion[data-open]').length) {
	$.each($('.accordion[data-open]'), function () {
		const $this = $(this);
		const windowHash = window.location.hash;
		const openByHashLength = $this.find(`.accordion__button[href="${windowHash}"]`).length
			|| $this.parents('.accordion').last().find(`.accordion__button[href="${windowHash}"]`).length;

		if (!openByHashLength) {
			const numOpenSection = $this.data('open');
			const sectionHref = $this
				.find('.accordion__section .accordion__button')
				.eq(numOpenSection - 1)
				.attr('href');
			const data = {href: sectionHref};

			openParents(data);
			openAccordion(data);
		}
	});
}



// WEBPACK FOOTER //
// ./temp/components/accordions/index.js